import { useCreatePortfolio } from './CreatePortfolioManager';

export const useCreatePortfolioState = () => {
    const { state } = useCreatePortfolio();

    return state;
};
